<template>
    <v-container fluid>
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">
                    Circle K - Electronic Data Interchange
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
                <v-row style="margin: 20px 0;">
                    <v-col cols="12" style="padding: 0;">
                        <div style="display: flex; align-items: center;">
                            <v-menu
                                offset-y
                                :close-on-content-click="false"
                                :nudge-width="300"
                                v-model="invoiceMenu"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                    >
                                        Select an invoice
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title style="padding-top: 30px;">
                                        Invoice List
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="invoiceSearch"
                                            append-icon="mdi-magnify"
                                            label="Search invoice"
                                            hide-details
                                            style="padding-top: 0;margin-top: 0;"
                                        ></v-text-field>
                                    </v-card-title>
                                    <v-data-table
                                        :headers="invoiceListHeaders"
                                        :items="invoiceList"
                                        @click:row="selectInvoice"
                                        dense
                                        max-height="150"
                                        fixed-header
                                        :search="invoiceSearch"
                                        style="cursor: pointer;"
                                        :loading="invoiceLoading"
                                        loading-text="Loading invoices..."
                                    ></v-data-table>
                                    <!--<v-pagination
                                        v-model="invoicePagination.page"
                                        :length="invoicePagination.itemsPerPage"
                                        :total-visible="invoicePagination.visible"
                                        style="padding: 10px 0;"
                                    ></v-pagination>-->
                                </v-card>
                            </v-menu>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        class="ma-2 white--text"
                                        @click="makeFuelFreightFromInvoice"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        Make
                                        <v-icon right dark>
                                            mdi-file-document-plus
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Make Fuel Freight from Invoice</span>
                            </v-tooltip>
                            <v-chip
                                v-if="invoiceChip"
                                close
                                close-icon="mdi-delete"
                                label
                                color="#AED6F1"
                                text-color="#01579b"
                                @click:close="deleteInvoiceSelection"
                                class="invoiceChipClss"
                            >
                                <table>
                                    <tr>
                                        <th>{{ invoiceChipValues.InvId }}</th>
                                        <th>{{ invoiceChipValues.InvDate }}</th>
                                        <th>
                                            {{ invoiceChipValues.CustName }}
                                        </th>
                                        <th>
                                            {{ invoiceChipValues.StartDate }}
                                        </th>
                                        <th>{{ invoiceChipValues.EndDate }}</th>
                                    </tr>
                                </table>
                            </v-chip>
                        </div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row style="margin-bottom: 20px;">
                    <v-col cols="12">
                        <template>
                            <v-card>
                                <v-card-title class="table-title">
                                    EDI Circle K Files
                                </v-card-title>
                                <v-data-table
                                    :headers="ckFileHeaders"
                                    :items="ckFiles"
                                    :search="ckFileSearch"
                                    fixed-header
                                    dense
                                    :loading="ckFilesLoading"
                                    loading-text="Loading files..."
                                >
                                    <template v-slot:top>
                                        <v-toolbar flat>
                                            <v-text-field
                                                v-model="ckFileSearch"
                                                append-icon="mdi-magnify"
                                                label="Search file"
                                                hide-details
                                            ></v-text-field>
                                            <v-spacer></v-spacer>
                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs
                                                    }"
                                                >
                                                    <v-btn
                                                        color="primary"
                                                        class="ma-2 white--text"
                                                        @click="
                                                            $store.state.ckedi.openFileSendingPanel = true
                                                        "
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        Open
                                                        <v-icon right dark>
                                                            mdi-file-eye
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span
                                                    >Open File Sending
                                                    Panel</span
                                                >
                                            </v-tooltip>
                                        </v-toolbar>
                                    </template>
                                    <template v-slot:item.actions="{ item }">
                                        <v-tooltip
                                            right
                                            v-if="
                                                item.perf_stats_decode != null
                                            "
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    small
                                                    class="ml-3"
                                                    @click="
                                                        openFuelFreight(item)
                                                    "
                                                >
                                                    mdi-eye
                                                </v-icon>
                                            </template>
                                            <div>
                                                <p
                                                    style="margin: 0;padding: 0;"
                                                >
                                                    Records:
                                                    {{
                                                        item.perf_stats_decode
                                                            .Records
                                                    }}
                                                </p>
                                                <p
                                                    style="margin: 0;padding: 0;"
                                                >
                                                    Request Duration:
                                                    {{
                                                        item.perf_stats_decode
                                                            .RequestDuration
                                                    }}
                                                </p>
                                                <p
                                                    style="margin: 0;padding: 0;"
                                                >
                                                    Start:
                                                    {{
                                                        item.perf_stats_decode
                                                            .Start
                                                    }}
                                                </p>
                                                <p
                                                    style="margin: 0;padding: 0;"
                                                >
                                                    End:
                                                    {{
                                                        item.perf_stats_decode
                                                            .End
                                                    }}
                                                </p>
                                            </div>
                                        </v-tooltip>
                                        <v-icon
                                            v-else
                                            small
                                            class="ml-3"
                                            @click="openFuelFreight(item)"
                                        >
                                            mdi-eye
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </template>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <FuelFreight
            v-if="$store.state.ckedi.openFuelFreight"
            :FileData="fileSelected"
        ></FuelFreight>

        <FileSendingPanel
            v-if="$store.state.ckedi.openFileSendingPanel"
        ></FileSendingPanel>

        <v-dialog
            v-model="existingFile"
            persistent
            max-width="350px"
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-card-title>Existing File</v-card-title>
                <v-card-text style="font-size: 16px;"
                    >There is already a file associated to the selected Invoice,
                    if you continue this will be updated, do you want to
                    continue?</v-card-text
                >
                <div
                    style="display: flex;justify-content: space-between;padding: 0 15px 15px 15px;"
                >
                    <v-btn
                        color="primary"
                        @click="fuelFreightFromInvoiceInterface('edit')"
                    >
                        Continue
                    </v-btn>
                    <v-btn text @click="existingFile = false">
                        Cancel
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="makeFFFInvConfirmation"
            persistent
            max-width="700px"
            transition="dialog-bottom-transition"
        >
            <v-card style="padding: 0 20px;">
                <v-card-title style="padding-left: 0;"
                    >Please confirm</v-card-title
                >
                <v-card-text style="font-size: 16px;padding-left: 0;"
                    >You will create a Fuel Freight from the following Invoice,
                    do you want to continue?</v-card-text
                >
                <table style="margin-bottom: 20px;">
                    <tr>
                        <th style="font-size: 14px;">InvId</th>
                        <th style="font-size: 14px;">InvDate</th>
                        <th style="font-size: 14px;">CustName</th>
                        <th style="font-size: 14px;">StartDate</th>
                        <th style="font-size: 14px;">EndDate</th>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">
                            {{ invoiceChipValues.InvId }}
                        </td>
                        <td style="font-size: 14px;">
                            {{ invoiceChipValues.InvDate }}
                        </td>
                        <td style="font-size: 14px;">
                            {{ invoiceChipValues.CustName }}
                        </td>
                        <td style="font-size: 14px;">
                            {{ invoiceChipValues.StartDate }}
                        </td>
                        <td style="font-size: 14px;">
                            {{ invoiceChipValues.EndDate }}
                        </td>
                    </tr>
                </table>

                <div
                    style="display: flex;justify-content: space-between;padding: 0 0 15px;"
                >
                    <v-btn
                        color="primary"
                        @click="fuelFreightFromInvoiceInterface('new')"
                    >
                        Continue
                    </v-btn>
                    <v-btn text @click="makeFFFInvConfirmation = false">
                        Cancel
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';
import FuelFreight from './FuelFreight.vue';
import FileSendingPanel from './FileSendingPanel.vue';

export default {
    props: [],
    components: {
        FuelFreight,
        FileSendingPanel
    },
    data: function() {
        return {
            invoiceSearch: '',
            invoiceSelected: null,
            invoiceList: [],
            invoiceListHeaders: [
                { text: 'InvId', value: 'InvId' },
                { text: 'InvDate', value: 'InvDate' },
                { text: 'CustName', value: 'CustName' },
                { text: 'StartDate', value: 'StartDate' },
                { text: 'EndDate', value: 'EndDate' }
            ],
            invoicePagination: {
                page: 1,
                itemsPerPage: 10,
                visible: 7
            },
            invoiceLoading: false,
            invoiceChip: false,
            invoiceMenu: false,
            invoiceChipValues: {
                InvId: '',
                InvDate: '',
                CustName: '',
                StartDate: '',
                EndDate: ''
            },
            fileSelected: null,
            ckFileSearch: '',
            ckFileHeaders: [
                { text: 'FileId', value: 'EdiFileID' },
                { text: 'InvId', value: 'InvId' },
                { text: 'File Type', value: 'FilenamePrefix' },
                { text: 'File Datetime', value: 'FileDttm' },
                { text: 'Vendor Code', value: 'MacsVendorCode' },
                { text: 'File Name', value: 'FilenameString' },
                { text: 'Submission Datetime', value: 'FileSubmissionDttm' },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            ckFiles: [],
            ckFilesLoading: false,
            existingFile: false,
            makeFFFInvConfirmation: false
        };
    },
    computed: {
        filteredInvoiceList: {
            get: function() {
                const filteredList = this.invoiceList.filter(invoice =>
                    this.includesSearch(invoice)
                );

                const startIndex =
                    (this.invoicePagination.page - 1) *
                    this.invoicePagination.itemsPerPage;
                const endIndex =
                    startIndex + this.invoicePagination.itemsPerPage;
                return filteredList.slice(startIndex, endIndex);
            }
        }
    },
    mounted() {
        this.loadInvoices();
        this.loadEDIFiles();
    },
    methods: {
        includesSearch: function(invoice) {
            return (
                String(invoice.InvId)
                    .toLowerCase()
                    .includes(this.invoiceSearch.toLowerCase()) ||
                String(invoice.InvDate)
                    .toLowerCase()
                    .includes(this.invoiceSearch.toLowerCase()) ||
                String(invoice.CustName)
                    .toLowerCase()
                    .includes(this.invoiceSearch.toLowerCase()) ||
                String(invoice.StartDate)
                    .toLowerCase()
                    .includes(this.invoiceSearch.toLowerCase()) ||
                String(invoice.EndDate)
                    .toLowerCase()
                    .includes(this.invoiceSearch.toLowerCase())
            );
        },
        loadInvoices: function() {
            this.invoiceLoading = true;
            axios
                .get('/ck-edi/invoices')
                .then(response => {
                    console.log(response.data);
                    this.invoiceList = response.data;
                    this.invoiceLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadEDIFiles: async function() {
            this.ckFiles = [];
            this.ckFilesLoading = true;
            await axios
                .get('/ck-edi')
                .then(response => {
                    console.log(response.data);
                    this.ckFiles = response.data;
                    this.ckFilesLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        makeFuelFreightFromInvoice: function() {
            console.log(this.invoiceSelected);
            // Check if there is an invoice selected
            if (!this.invoiceSelected) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You have to select an Invoice.'
                });
                return;
            }

            // Check if there is already a file related to that InvId
            let file = this.ckFiles.filter(
                f => f.InvId == this.invoiceSelected.InvId
            );
            console.log(file);
            if (file.length) {
                if (file[0].FileSubmissionDttm !== null) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'A file associated with this InvId has already been sent.'
                    });
                    return;
                }

                this.existingFile = true;
            } else {
                this.makeFFFInvConfirmation = true;
            }
        },
        openFuelFreight: async function(file) {
            console.log(file);
            this.$store.state.isLoading = true;
            await axios
                .post('/ck-edi/fuel-freight', file)
                .then(response => {
                    console.log(response.data);
                    this.fileSelected = response.data;
                    this.fileSelected.generalFileInfo = file;
                    this.$store.state.isLoading = false;
                    this.$store.state.ckedi.openFuelFreight = true;
                })
                .catch(function(error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        selectInvoice: function(invoice) {
            console.log(invoice);
            this.invoiceSelected = invoice;
            this.invoiceChipValues.InvId = invoice.InvId;
            this.invoiceChipValues.InvDate = invoice.InvDate;
            this.invoiceChipValues.CustName = invoice.CustName;
            this.invoiceChipValues.StartDate = invoice.StartDate;
            this.invoiceChipValues.EndDate = invoice.EndDate;
            this.invoiceChip = true;
            this.invoiceMenu = false;
        },
        deleteInvoiceSelection: function() {
            this.invoiceChip = false;
            this.invoiceSelected = null;
            this.invoiceChipValues.InvId = '';
            this.invoiceChipValues.InvDate = '';
            this.invoiceChipValues.CustName = '';
            this.invoiceChipValues.StartDate = '';
            this.invoiceChipValues.EndDate = '';
        },
        fuelFreightFromInvoiceInterface: function(type) {
            this.existingFile = false;
            this.makeFFFInvConfirmation = false;
            this.$store.state.isLoading = true;
            console.log(type);
            let params = {
                Type: type,
                Invoice: this.invoiceSelected
            };
            axios
                .post('/ck-edi/fuel-freight-from-invoice', params)
                .then(response => {
                    console.log(response.data);
                    this.deleteInvoiceSelection();
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text:
                            type == 'new'
                                ? 'Fuel Freight successfully created.'
                                : 'Fuel Freight successfully edited.'
                    });
                    this.loadEDIFiles();
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>

<style scoped>
.table-title {
    max-width: 465px;
    border-bottom-right-radius: 15px;
    padding: 10px 16px;
    border-bottom: 1px solid #9e9e9e;
    border-right: 1px solid #9e9e9e;
    margin-bottom: 20px;
    background-color: #01579b;
    color: #fefeff;
}
table {
    border-collapse: collapse;
    width: 100%;
}
th,
td {
    border: 1px solid #dddddd;
    padding: 8px;
    text-align: left;
}
.invoiceChipClss {
    padding-left: 0 !important;
}
.invoiceChipClss th {
    padding: 4px;
    border: unset;
    border: 2px solid #8dbde3;
    font-size: 12px;
    background-color: #fff;
}
.v-dialog__content--active {
    background-color: rgba(0, 0, 0, 0.7);
}

.v-dialog__content {
    opacity: 0.995;
}
</style>
